import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Translate } from '../../../../../../shared/LanguageService';
import BaseTab from './BaseTab';

const CustomerCalendarRoute = '/customer-calendar';

function CustomerCalendarTab({
    history,
    location,
    match,
    staticContext,
    ...props
}: RouteComponentProps) {
    function handleClick() {
        history.push(CustomerCalendarRoute);
    }

    return (
        <BaseTab
            {...props}
            onClick={handleClick}
            label={Translate('header/nav/calendar')}
            route={CustomerCalendarRoute}
        />
    );
}

const RoutedCustomerCalendarTab = Object.assign(withRouter(CustomerCalendarTab), {
    routes: [CustomerCalendarRoute]
});

export default RoutedCustomerCalendarTab;
